import { useEffect, useState } from "react";
import { BadgeCheck, Loader2 } from "lucide-react";
import { today, shortDate } from "@/lib/invoice";
import DateField from "@/components/DateField";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";

export default function MarkPaidDialog({ open, count, what = "invoice", showNote, onClose, onConfirm }) {
  const [date, setDate] = useState(today());
  const [note, setNote] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (open) { setDate(today()); setNote(""); } }, [open]);

  const save = async () => {
    setBusy(true);
    await onConfirm(date.slice(0, 10), shortDate(date), note.trim());
    setBusy(false);
  };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-sm bg-card" data-testid="mark-paid-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl">Mark {count} {what}{count === 1 ? "" : "s"} paid</DialogTitle>
          <DialogDescription>Choose the date paid that goes in Date Pd.</DialogDescription>
        </DialogHeader>
        <div className="space-y-1.5">
          <Label htmlFor="mark-paid-date">Date paid</Label>
          <DateField id="mark-paid-date" value={date} onChange={(v) => setDate(v || today())} />
        </div>
        {showNote && (
          <div className="space-y-1.5">
            <Label htmlFor="mark-paid-note">Payment note (optional)</Label>
            <Input id="mark-paid-note" value={note} onChange={(e) => setNote(e.target.value)} maxLength={300} placeholder="e.g. Check 1043" data-testid="mark-paid-note" />
          </div>
        )}
        <DialogFooter>
          <Button variant="ghost" onClick={onClose} data-testid="mark-paid-cancel">Cancel</Button>
          <Button onClick={save} disabled={busy} className="bg-emerald-600 hover:bg-emerald-500" data-testid="mark-paid-confirm">
            {busy ? <Loader2 size={15} className="animate-spin" /> : <BadgeCheck size={15} />} Mark paid
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
